// extracted by mini-css-extract-plugin
module.exports = {"detailSpeakers":"EventDetailsSpeakers_detailSpeakers__wOluI","speakerDetails":"EventDetailsSpeakers_speakerDetails__oB9Fl","speakerList":"EventDetailsSpeakers_speakerList__uok1F"};